module.exports = __webpack_public_path__ + "static/img/img_logo.cf1761a1.png";